import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IInvoiceSubcontractLine extends IBaseEntity {
    id?: number;
    subContractor: any;
    subContractorId: number;
    rate: number;
    discount: number;
    total: number;
}

export class InvoiceSubcontractLine extends BaseEntity implements IInvoiceSubcontractLine {
    public id?: number;
    public subContractor: any;
    public subContractorId: number;
    public rate: number;
    public discount: number;
    public total: number;

    constructor(invoiceSubcontractLine?: any) {
        super();
        if (invoiceSubcontractLine) {
            this.id = invoiceSubcontractLine.id;
            this.subContractor = invoiceSubcontractLine.subContractorDTO;
            this.subContractorId = invoiceSubcontractLine.subContractorId;
            this.rate = invoiceSubcontractLine.rate;
            this.discount = invoiceSubcontractLine.discount;
            this.total = invoiceSubcontractLine.total;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): InvoiceSubcontractLine {
        return new InvoiceSubcontractLine(this);
    }
}
